import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiFormControlLayoutDelimited, EuiFormLabel, EuiPanel, EuiText } from '@elastic/eui';
import React, { useMemo, useState } from 'react';
import { stringToFloat } from '../../../../../shared/utils/numbers';

export const NuevoRepartoCP = (props) =>{

    const {onRepartoAdd} = props
    const [cp, setCP] = useState('');
    const [porcentaje, setPorcentaje] = useState('1')

    const isInvalidCP = useMemo(()=> cp===undefined || cp==='' || cp.length<3 ,[cp])
    
    const clear = () =>{
        setCP('')
        setPorcentaje('1')
    }

    const onAdd = () => {
        const newData = {idCP:cp,porcentaje:stringToFloat(porcentaje),isDeleteable:true}
        onRepartoAdd(newData)
        clear()
    }

    const msgInvalidParams = useMemo(()=>{
     if(isInvalidCP){
        return(
            <EuiFlexItem><EuiText color={'danger'}>{`Error en el código del centro. Debe de tener 3 dígitos`}</EuiText></EuiFlexItem> 
        )
     }  
    },[isInvalidCP])

    return(
        <>
        <EuiFlexGroup>
        <EuiFlexItem grow={false}>
        <EuiFormControlLayoutDelimited
            compressed
            prepend={<EuiFormLabel>CP</EuiFormLabel>}
            append={<EuiFormLabel>%</EuiFormLabel>}
            startControl={
                <input
                type="text"
                value={cp}
                minLength={3}
                maxLength={3}
                className="euiFieldNumber"
                onChange={(e)=> setCP(e.target.value)}
                />
            }
            delimiter="|"
            endControl={
                <input
                type="number"
                value={porcentaje}
                min={1}
                max={100}
                className="euiFieldNumber"
                onChange={(e)=> setPorcentaje(e.target.value)}
                />
            }
            />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiButton fill size='s' disabled={isInvalidCP} onClick={()=>onAdd()}>{`Agregar`}</EuiButton>
            </EuiFlexItem> 
            {msgInvalidParams}
        </EuiFlexGroup>
        </>
    )
}